import React, { useState } from "react";
import "./RealEstateServices.css";

const services = [
  {
    id: 1,
    category: "buyers",
    title: "Confident Home Buying",
    summary: "Clear guidance so you never feel rushed, pressured, or unsure.",
    details:
      "From your first showing to closing day, I help you understand pricing, neighborhoods, and resale value — not just what looks good today. My clients make informed decisions and avoid costly surprises.",
    route: "/buyers",
    routeLabel: "Buyer Guide",
  },
  {
    id: 2,
    category: "sellers",
    title: "Strategic Home Selling",
    summary: "Pricing, presentation, and negotiation done the right way.",
    details:
      "I combine local market knowledge with professional design insight to position your home for maximum value. That means smart pricing, strong visuals, and a strategy that attracts serious buyers — not just traffic.",
    route: "/sellers",
    routeLabel: "Seller Guide",
  },
];

export default function RealEstateServices() {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="re-services">
      <div className="re-services-grid">
        {services.map((service) => {
          const open = expandedId === service.id;

          return (
            <div
              key={service.id}
              className={`re-service-card ${open ? "open" : ""}`}
              onClick={() => setExpandedId(open ? null : service.id)}
            >
              <h3>{service.title}</h3>
              <p>{service.summary}</p>

              {open && (
                <>
                  <p className="details">{service.details}</p>

                  {service.route && (
                    <div style={{ marginTop: "1rem" }}>
                      <a
                        href={service.route}
                        className="btn accent small"
                        onClick={(e) => e.stopPropagation()}
                      >
                        View {service.routeLabel}
                      </a>
                    </div>
                  )}
                </>
              )}

              <span className="toggle">
                {open ? "Hide details ↑" : "Learn more ↓"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
